import React, { Fragment } from 'react'
import { useGallery, GalleryProps } from './useGallery'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Parallax } from 'swiper/modules'
import styles from './Gallery.module.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const Gallery: React.FC<GalleryProps> = (props: GalleryProps) => {
  const { departmentDetails } = useGallery(props)

  return departmentDetails && departmentDetails.length ? (
    <section id='department-gallery' className={styles['gallery-container']}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className={styles.gallery}>
              <Swiper
                dir='rtl'
                navigation
                loop
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                style={
                  {
                    '--swiper-navigation-color':
                      'color-mix(in srgb, #fff, transparent 40%)',
                    '--swiper-pagination-color':
                      'color-mix(in srgb, #fff, transparent 40%)',
                  } as React.CSSProperties
                }
                parallax={true}
                modules={[Navigation, Pagination, Parallax]}
                className={styles.swiper}
                data-swiper-parallax='-23%'
              >
                {departmentDetails[0].photoGallery.map((item, index) => (
                  <SwiperSlide
                    key={`department-gallery-${index}`}
                    className={styles.slide}
                  >
                    <img
                      src={item}
                      alt='department gallery item'
                      className={styles.item}
                      loading='lazy'
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Fragment />
  )
}

export default Gallery
